module.exports = __webpack_public_path__ + "static/karol-d17ad0d388599e7d24e8f66a0288246c.jpg";